import styled from 'styled-components'
import { Button } from 'components/atoms'
import React from 'react'

export const PrintButtonComponent = styled(({ children, ...props }) =>
  React.createElement(Button, props, children)
)`
  display: inline-flex;
  align-self: flex-start;
  cursor: pointer;

  margin-bottom: 15px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }

  .btn {
    line-height: 22px;
  }

  .label {
    text-decoration: underline;
  }
`
